export default __webpack_public_path__ + "static/media/class_xi_xii_engg_tab.1aa54d54.png";